import React from "react";
import PropTypes from "prop-types";

var Pager = function Pager(_ref) {
  var total = _ref.total,
      _ref$current = _ref.current,
      current = _ref$current === undefined ? 1 : _ref$current,
      renderItem = _ref.renderItem,
      renderPrev = _ref.renderPrev,
      renderNext = _ref.renderNext,
      contentLabel = _ref.contentLabel;

  var items = [];

  if (total > 3) {
    // this specifies the range of pages we want to show in the middle
    var start = Math.max(total - current <= 3 ? total - 4 : current - 2, 2);
    var end = Math.min(current <= 4 ? 5 : current + 2, total - 1);

    // we always show the first page
    items.push({ key: 1, value: 1 });

    // we're more than one space away from the beginning, so we need a separator
    if (start > 2) {
      items.push({ key: "ellip-1", value: "..." });
    }

    // generate the middle numbers
    for (var i = start; i < end + 1; i += 1) {
      items.push({ key: i, value: i });
    }

    // we're more than one space away from the end, so we need a separator
    if (end < total - 1) {
      items.push({ key: "ellip-2", value: "..." });
    }

    // we always show the last page
    items.push({ key: total, value: total });
  } else {
    // we must special-case three or less, because the above logic won't work
    // generate the middle numbers
    for (var _i = 1; _i <= total; _i += 1) {
      items.push({ key: _i, value: _i });
    }
  }

  var prevItem = current > 1 && React.createElement(
    "li",
    { key: "prev" },
    renderPrev(current - 1)
  );

  var nextItem = current < total && React.createElement(
    "li",
    { key: "next" },
    renderNext(current + 1)
  );

  return React.createElement(
    "nav",
    { "aria-label": contentLabel },
    React.createElement(
      "ul",
      { className: "pager" },
      prevItem,
      items.map(function (_ref2) {
        var key = _ref2.key,
            value = _ref2.value;
        return value === "..." ? React.createElement(
          "li",
          { key: key },
          "\u2026"
        ) : React.createElement(
          "li",
          {
            key: key,
            className: value === current ? "pager__current" : null
          },
          renderItem(value, current)
        );
      }),
      nextItem
    )
  );
};

Pager.propTypes = process.env.NODE_ENV !== "production" ? {
  total: PropTypes.number.isRequired,
  current: PropTypes.number.isRequired,
  renderItem: PropTypes.func.isRequired,
  renderPrev: PropTypes.func.isRequired,
  renderNext: PropTypes.func.isRequired,
  contentLabel: PropTypes.string.isRequired
} : {};

export default Pager;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/es/components/pager/index.js
// module id = null
// module chunks = 